import { Container } from "@nextui-org/react"
import { Text } from "@nextui-org/react"

import { bounceSlow } from '../../ui/animation'
import Dialog from "./dialog"
import { Content } from "../../ui/layout/content"
import StartupIcon from '../../ui/resources/GL_startup.png'
import AcademicIcon from '../../ui/resources/GL_academic.png'
import Bkg from '../../ui/resources/GL_section_bkg_1.png'

export default ({}) => {
    return (
        <>
            {/* <img 
                src={Bkg} 
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "50%",
                    zIndex: -1
                }}/> */}
            {/* <Reveal
                keyframes={bounceSlow}
                cascade={true}
                triggerOnce={true}
                fraction={0.8}> */}
                <Content>
                    <Container xs={12} sm={6} md={4} css={{position: "relative", height: "200px"}}>
                        <img src={StartupIcon} width="50px" style={{bottom: 0, left:0, position: "absolute"}}/>
                        <Dialog 
                            isStartup
                            text="I’m solving a business problem. I want to build market differentiating capabilities."/>
                    </Container>
                </Content>
                <Content spacerSize={2}>
                    <Container xs={12} sm={6} md={4} css={{position: "relative"}}>
                        <Dialog 
                            text="I’m a researcher. I’m looking for collaboration with industry."/>
                        <img src={AcademicIcon} width="50px"  style={{bottom: "-30px", right: 0, position: "absolute"}}/>
                    </Container>
                </Content>
            {/* </Reveal> */}
            <Content spacerSize={2}></Content>
        </>
    )
}